export default __webpack_public_path__ + "media/images/icons/mpi-outline-687dad9a4077d3c14b1c39c6a803b885.svg";